import { ImageField, maxLength } from "react-admin"

export  const PreviewImage = ({ record, source }) => {
    if (typeof (record) == "string") {
        record = {
            [source]: record
        }
    }
    return <ImageField className="RaImageField-image-preview" record={record} source={source} />
  }